"use client"

import {useAppStore} from "@/store/AppStore";
import usePlaceTypesData from "@/utils/hooks/usePlaceTypesData";
import usePlaceCategoriesData from "@/utils/hooks/usePlaceCategoriesData";
import {useEffect} from "react";

export default function LoadAppData() {
  const appStore = useAppStore()
  const placeTypesData = usePlaceTypesData()
  const placeCategpriesData = usePlaceCategoriesData()
  useEffect(() => {
    if (!placeTypesData?.items || !placeCategpriesData?.items) return
    appStore.setTypes(placeTypesData.items)
    appStore.setCats(placeCategpriesData.items)
  }, [appStore, placeCategpriesData, placeTypesData])

  return null
}
